module.exports = __webpack_public_path__ + "img/clermont-logo-icon.3bea995e.png";